module.exports = __webpack_public_path__ + "static/media/Email.59552f4f.svg";